import { protectedRoute } from "@/utils/routeUtils";

const allowedRoles = ["SUPER_ADMIN", "MANAGER", "OFFICER"];

const facilitiesRoutes = {
  path: "facilities",
  title: "module_title.facilities_management",
  sidebarProps: {
    key: "1-11",
    iconSrc: "facilities",
    label: "module_title.facilities",
    link: "/facilities",
    groupingType: "TOOLS",
    order: 11,
    permissions: allowedRoles,
  },
  element: protectedRoute(
    [() => import("@/pages/facilities/FacilitiesList")],
    allowedRoles
  ),
};

export default facilitiesRoutes;
